import axios from 'axios'

export default {
  create: (context, payload) => {
    // eslint-disable-next-line no-unused-vars
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.post('plant', payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  edit: (context, payload) => {
    // eslint-disable-next-line no-unused-vars
    const { commit } = context
    const { id } = payload

    return new Promise((resolve, reject) => {
      axios.put(`plant/${id}`, payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  list: (context, payload) => {
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.get('plant', {
        params: payload,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          const rows = response.data

          commit('setPlants', rows)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
